import { BookingData } from "../../AppDataProvider/AppDataProvider";

export type ReadyEventPayload = {
  data: {
    iFrameId: string;
  };
  name: "READY";
};

export type ClosePopoverEventPayload = {
  data: {
    iFrameId: string;
  };
  name: "CLOSE_APPOINTEDD_POPOVER";
};

export type UserEngagedEventPayload = {
  data: {
    iFrameId: string;
  };
  name: "USER_ENGAGED";
};

export type LocationSearchedEventPayload = {
  data: {
    iFrameId: string;
    location: string;
  };
  name: "LOCATION_SEARCHED";
};

export type LocationDateTimeSearchedEventPayload = {
  data: {
    date: string;
    iFrameId: string;
    location: string;
    time: string;
  };
  name: "LOCATION_DATE_TIME_SEARCHED";
};

export type BookingCreatedEventPayload = {
  data: {
    booking: BookingData;
    iFrameId: string;
  };
  name: "BOOKING_CREATED";
};

export type BookingSlotReserved = {
  data: {
    iFrameId: string;
    organisationId: string;
    reservationSlotId: string;
    selectedTimeSlot: string;
  };
  name: "BOOKING_SLOT_RESERVED";
};

export type StepEventNames = "CUSTOMER_DETAILS_STEP";

export type StepPayload = {
  data: Omit<BookingData, "bookings" | "organisation" | "service"> & {
    iFrameId: string;
    organisation?: Partial<
      Pick<NonNullable<BookingData["organisation"]>, "_id" | "name" | "slug">
    >;
    service?: Omit<NonNullable<BookingData["service"]>, "organisation">;
  };
  name: StepEventNames;
};

export type ExternalLinkClickedPayload = {
  data: {
    iFrameId: string;
    url: string;
  };
  name: "EXTERNAL_LINK_CLICKED";
};

export type ClosePopoverReservedEventPayload = {
  data: {
    iFrameId: string;
    organisationId: string;
    reservationSlotId: string;
    selectedTimeSlot: string;
  };
  name: "CLOSE_APPOINTEDD_POPOVER_RESERVED";
};

export type BookingCancelledEventPayload = {
  data: {
    iFrameId: string;
  };
  name: "BOOKING_CANCELLED";
};

export type EmitEventPayload =
  | BookingCancelledEventPayload
  | BookingCreatedEventPayload
  | BookingSlotReserved
  | ClosePopoverEventPayload
  | ClosePopoverReservedEventPayload
  | ExternalLinkClickedPayload
  | LocationDateTimeSearchedEventPayload
  | LocationSearchedEventPayload
  | ReadyEventPayload
  | StepPayload
  | UserEngagedEventPayload;

export const emitEvent = function (payload: EmitEventPayload) {
  return parent.window.postMessage(
    "APPOINTEDD-BOOKING-TOOL." + JSON.stringify(payload),
    "*",
  );
};
